// JQuery is not used, but may be called. This prevents uncaught errors.
(() => {
    // If $ is not defined, define a minimal mock
    if (typeof window.$ === "undefined") {
        window.$ = function () {
            return {
                on: () => { },
                click: () => { },
                val: () => "",
                text: () => "",
                // Add more no-ops as needed
            };
        };
    }
})();

function getFocusableElements(container) {
    const elements = Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));

    // Remove elements that have tabindex of -1 or inert.
    const focusableElements = elements.filter((element) => {
        if (element.getAttribute("tabindex") === "-1") return false;
        if (element.hasAttribute("inert")) return false;
        if (element.closest('.facets__sub-list--hidden')) return false;
        if (element.closest('.no-js')) return false;

        return true;
    });

    return focusableElements;
}

const initDetailSummaries = () => {
    document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
        if (summary.hasAttribute('data-custom-summary')) return;
        if (summary.hasAttribute("aria-expanded")) return;

        const detail = summary.closest("details");
        const content = summary.nextElementSibling;

        summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open"));
    
        // if (content.getAttribute("id")) {
        //     summary.setAttribute("aria-controls", content.id);
        // }
    
        const toggleDetails = (open, autofocus = true) => {
            summary.setAttribute("aria-expanded", open);

            if (detail.dataset.panelInline) return;
            if (open) trapFocus(content, { autofocus });
            else removeTrapFocus(summary);
        };
    
        summary.addEventListener("click", (event) => {
            toggleDetails(!event.currentTarget.closest("details").hasAttribute("open"));
        });
    
        if (summary.closest("header-drawer")) return;
        if (!detail.dataset.panelInline) summary.parentElement.addEventListener("keyup", onKeyUpEscape);

        if (detail.hasAttribute("open")) toggleDetails(true, false);
    });
}
initDetailSummaries();

const trapFocusHandlers = {};
function trapFocus(container, { focusElement = container, autofocus = true, escapeHandler = null } = { focusElement: container }) {
    if (focusElement === false) focusElement = container;

    var focusableElements = getFocusableElements(container);
    var first = focusableElements[0];
    var last = focusableElements[focusableElements.length - 1];

    removeTrapFocus();

    const isInsideContainer = (element) => container.contains(element);

    let tabKeyPressed = false;
    trapFocusHandlers.focusin = (event) => {
        if (event.target !== container && event.target !== last && event.target !== first) return;
        document.addEventListener("keydown", trapFocusHandlers.keydown);
        document.addEventListener("keyup", trapFocusHandlers.keyup);
    };

    trapFocusHandlers.focusout = function (event) {
        document.removeEventListener("keydown", trapFocusHandlers.keydown);
        document.removeEventListener("keyup", trapFocusHandlers.keyup);

        if (!tabKeyPressed) return;

        // Ensure element still focused, otherwise focus the first element.
        if (!isInsideContainer(event.relatedTarget)) focusElement.focus();
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.key !== "Tab") return; // If not TAB key
        tabKeyPressed = true;

        //  On the first focusable element and tab backward, focus the last element.
        if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus();
            return;
        }

        if (!isInsideContainer(event.target)) {
            event.preventDefault();
            first.focus();
            return;
        }
    };

    trapFocusHandlers.keyup = function (event) {
        if (event.key === "Tab") tabKeyPressed = false;
    };

    // Setup Escape handler.
    if (typeof escapeHandler === 'function') {
        trapFocusHandlers.escape = function (event) {
            if (event.key !== "Escape") return;
            const focusElement = escapeHandler();
            removeTrapFocus(focusElement || null);
        };
        document.addEventListener("keydown", trapFocusHandlers.escape);
    }

    document.addEventListener("focusout", trapFocusHandlers.focusout);
    document.addEventListener("focusin", trapFocusHandlers.focusin);

    const disallowedElements = ['summary'];
    if (!focusElement.hasAttribute('tabindex') && !disallowedElements.includes(focusElement.tagName.toLowerCase()))
        focusElement.setAttribute('tabindex', '0');
    
    if (autofocus) focusElement.focus();

    if (focusElement.tagName === "INPUT" && ["search", "text", "email", "url"].includes(focusElement.type) && focusElement.value) {
        focusElement.setSelectionRange(0, focusElement.value.length);
    }
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin);
    document.removeEventListener("focusout", trapFocusHandlers.focusout);
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
    document.removeEventListener("keydown", trapFocusHandlers.escape);
    document.removeEventListener("keyup", trapFocusHandlers.keyup);

    if (elementToFocus) elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(":focus-visible");
} catch (e) {
    focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
    const navKeys = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"];
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener("keydown", (event) => {
        if (navKeys.includes(event.code.toUpperCase())) {
            mouseClick = false;
        }
    });

    window.addEventListener("mousedown", (event) => {
        mouseClick = true;
    });

    window.addEventListener(
        "focus",
        () => {
            if (currentFocusedElement) currentFocusedElement.classList.remove("focused");

            if (mouseClick) return;

            currentFocusedElement = document.activeElement;
            currentFocusedElement.classList.add("focused");
        },
        true
    );
}

function pauseAllMedia() {
    document.querySelectorAll(".js-youtube").forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
    });
    document.querySelectorAll(".js-vimeo").forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', "*");
    });
    document.querySelectorAll("video").forEach((video) => video.pause());
    document.querySelectorAll("product-model").forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
    });
}

function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector("summary");

    openDetailsElement.removeAttribute("open");
    summaryElement.setAttribute("aria-expanded", false);
    summaryElement.focus();
}

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector("input");
        this.changeEvent = new Event("change", { bubbles: true });

        this.input.addEventListener("change", this.onInputChange.bind(this));
        this.querySelectorAll("button").forEach((button) => button.addEventListener("click", this.onButtonClick.bind(this)));
    }

    quantityUpdateUnsubscriber = undefined;

    connectedCallback() {
        this.validateQtyRules();
        this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
    }

    disconnectedCallback() {
        if (this.quantityUpdateUnsubscriber) {
            this.quantityUpdateUnsubscriber();
        }
    }

    onInputChange(event) {
        this.validateQtyRules();
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }

    validateQtyRules() {
        const value = parseInt(this.input.value);
        if (this.input.min) {
            const min = parseInt(this.input.min);
            const buttonMinus = this.querySelector(".quantity__button[name='minus']");
            buttonMinus.classList.toggle("disabled", value <= min);
        }
        if (this.input.max) {
            const max = parseInt(this.input.max);
            const buttonPlus = this.querySelector(".quantity__button[name='plus']");
            buttonPlus.classList.toggle("disabled", value >= max);
        }

        this.input.value = value;
    }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

function fetchConfig(type = "json") {
    return {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: `application/${type}` }
    };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
    window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
    return function () {
        return fn.apply(scope, arguments);
    };
};

Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options["method"] || "post";
    var params = options["parameters"] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

    Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
        var value = this.countryEl.getAttribute("data-default");
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function () {
        var value = this.provinceEl.getAttribute("data-default");
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function (e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute("data-provinces");
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = "none";
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement("option");
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function (selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function (selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement("option");
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    }
};

class MenuDrawer extends HTMLElement {
    constructor() {
        super();

        this.mainDetailsToggle = this.querySelector("details");

        this.addEventListener("keyup", this.onKeyUp.bind(this));
        this.addEventListener("focusout", this.onFocusOut.bind(this));
        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll("summary").forEach((summary) => summary.addEventListener("click", this.onSummaryClick.bind(this)));
        this.querySelectorAll("button:not(.localization-selector)").forEach((button) => button.addEventListener("click", this.onCloseButtonClick.bind(this)));
    }

    onKeyUp(event) {
        if (event.code.toUpperCase() !== "ESCAPE") return;

        const openDetailsElement = event.target.closest("details[open]");
        if (!openDetailsElement) return;

        openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const parentMenuElement = detailsElement.closest(".has-submenu");
        const isOpen = detailsElement.hasAttribute("open");
        const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

        function addTrapFocus() {
            trapFocus(summaryElement.nextElementSibling, { focusElement: detailsElement.querySelector("button") });
            summaryElement.nextElementSibling.removeEventListener("transitionend", addTrapFocus);
        }

        if (detailsElement === this.mainDetailsToggle) {
            if (isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

            if (window.matchMedia("(max-width: 990px)")) {
                document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
            }
        } else {
            setTimeout(() => {
                detailsElement.classList.add("menu-opening");
                summaryElement.setAttribute("aria-expanded", true);
                parentMenuElement && parentMenuElement.classList.add("submenu-open");
                !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener("transitionend", addTrapFocus);
            }, 100);
        }
    }

    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add("menu-opening");
        });
        summaryElement.setAttribute("aria-expanded", true);
        trapFocus(this.mainDetailsToggle, { focusElement: summaryElement });
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event === undefined) return;

        this.mainDetailsToggle.classList.remove("menu-opening");
        this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
            details.removeAttribute("open");
            details.classList.remove("menu-opening");
        });
        this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((submenu) => {
            submenu.classList.remove("submenu-open");
        });
        document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
        removeTrapFocus(elementToFocus);
        this.querySelector('[aria-expanded]').setAttribute("aria-expanded", false);
        this.closeAnimation(this.mainDetailsToggle);
    }

    onFocusOut() {
        setTimeout(() => {
            if (this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest("details");
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        const parentMenuElement = detailsElement.closest(".submenu-open");
        parentMenuElement && parentMenuElement.classList.remove("submenu-open");
        detailsElement.classList.remove("menu-opening");
        detailsElement.querySelector("summary").setAttribute("aria-expanded", false);
        removeTrapFocus(detailsElement.querySelector("summary"));
        this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute("open");
                if (detailsElement.closest("details[open]")) {
                    trapFocus(detailsElement.closest("details[open]"), {
                        focusElement: detailsElement.querySelector("summary")
                    });
                }
            }
        };

        window.requestAnimationFrame(handleAnimation);
    }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }

    openMenuDrawer(summaryElement) {
        this.header = this.header || document.querySelector(".section-header");
        this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0;
        document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
        this.header.classList.add("menu-open");

        setTimeout(() => {
            this.mainDetailsToggle.classList.add("menu-opening");
        });

        summaryElement.setAttribute("aria-expanded", true);
        window.addEventListener("resize", this.onResize);
        trapFocus(this.mainDetailsToggle, { focusElement: summaryElement });
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus) {
        if (!elementToFocus) return;
        super.closeMenuDrawer(event, elementToFocus);
        this.header.classList.remove("menu-open");
        window.removeEventListener("resize", this.onResize);
    }

    onResize = () => {
        this.header && document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
        document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
    };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
    connectedCallback() {
        if (this.moved) return;

        // Move to the end of the DOM.
        this.moved = true;
        document.body.appendChild(this);

        this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, false));
        this.addEventListener("keyup", this.onKeyUp);
        this.addEventListener("keydown", this.onKeyDown);
        this.addEventListener('focusout', this.onFocusOut);

        if (this.classList.contains("media-modal")) {
            this.addEventListener("pointerup", (event) => {
                if (event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model")) this.hide();
            });
        } else {
            this.addEventListener("click", (event) => {
                if (event.target === this) this.hide();
            });
        }

        if (this.dataset.autoOpen === "true") {
            if (this.dataset.cookieClose) {
                // check if cookie is set
                const cookie = document.cookie.split(";").find((cookie) => cookie.trim().startsWith(`${this.dataset.cookieClose}=`));
                if (cookie) return;
            }
            this.show();
        } else {
            this.setAttribute('inert', '');
        }
    }

    show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector(".template-popup");
        document.body.classList.add("overflow-hidden");
        this.removeAttribute('inert');
        this.setAttribute("open", "");
        if (popup) popup.loadContent();
        window.pauseAllMedia();

        // Focus role="dialog" element
        const dialog = this.querySelector('[role="dialog"]');
        dialog.setAttribute('tabindex', '0');
        dialog.focus();
    }

    hide() {
        document.body.classList.remove("overflow-hidden");
        document.body.dispatchEvent(new CustomEvent("modalClosed"));
        this.removeAttribute("open");
        window.pauseAllMedia();
        this.setAttribute('inert', '');

        if (this.dataset.cookieClose) {
            // set cookie to prevent modal from opening again
            const date = new Date();
            date.setTime(date.getTime() + 1000 * 60 * 60 * 24 * 365);
            document.cookie = `${this.dataset.cookieClose}=true; expires=${date.toGMTString()}; path=/`;
        }

        if (this.openedBy) this.openedBy.focus();
    }

    onKeyUp(event) {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        this.hide();
    }

    onKeyDown(event) {
        if (event.key !== 'Tab') return;
        const focusableElements = getFocusableElements(this);

        if (focusableElements.length === 0) {
            // Focus on dialog.
            event.preventDefault();
            this.focus();
            return;
        }

        if (event.shiftKey) {
            if (event.target === focusableElements[0]) {
                event.preventDefault();
                focusableElements[focusableElements.length - 1].focus();
            }
        } else {
            if (event.target === focusableElements[focusableElements.length - 1]) {
                event.preventDefault();
                focusableElements[0].focus();
            }
        }
    }

    onFocusOut(event) {
        if (event.target === this) return;
        const focusableElements = getFocusableElements(this);
        const isInsideContainer = (element) => this.contains(element);
        if (isInsideContainer(event.relatedTarget)) return;
        event.preventDefault();
        focusableElements[0].focus();
    }

}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
    constructor() {
        super();

        const button = this.querySelector("button");

        if (!button) return;
        button.addEventListener("click", (event) => {
            const modalSelector = this.getAttribute("data-modal");
            const modal = document.querySelector(modalSelector);
            if (modal) {
                event.preventDefault();
                modal.show(button);
            }
            publish(PUB_SUB_EVENTS.modalOpened, {
                data: {
                    selector: modalSelector,
                    opener: this
                }
            });
        });
    }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        poster.addEventListener("click", this.loadContent.bind(this));
    }

    loadContent(focus = true) {
        window.pauseAllMedia();
        if (!this.getAttribute("loaded")) {
            const content = document.createElement("div");
            content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

            this.setAttribute("loaded", true);
            const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
            if (focus) deferredElement.focus();
            if (deferredElement.nodeName == "VIDEO" && deferredElement.getAttribute("autoplay")) {
                // force autoplay for safari
                deferredElement.play();
            }
        }
    }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector('[id^="Slider-"]');
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.enableSliderLooping = false;
        this.currentPageElement = this.querySelector(".slider-counter--current");
        this.pageTotalElement = this.querySelector(".slider-counter--total");
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');

        if (!this.slider || !this.nextButton) return;

        this.initPages();
        const resizeObserver = new ResizeObserver((entries) => this.initPages());
        resizeObserver.observe(this.slider);

        this.slider.addEventListener("scroll", this.update.bind(this));
        this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
        this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    }

    initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
        if (this.sliderItemsToShow.length < 2) return;
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
        this.update();
    }

    resetPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.initPages();
    }

    update() {
        // Temporarily prevents unneeded updates resulting from variant changes
        // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
        if (!this.slider || !this.nextButton) return;

        const previousPage = this.currentPage;
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

        if (this.currentPageElement && this.pageTotalElement) {
            this.currentPageElement.textContent = this.currentPage;
            this.pageTotalElement.textContent = this.totalPages;
        }

        if (this.currentPage != previousPage) {
            this.dispatchEvent(
                new CustomEvent("slideChanged", {
                    detail: {
                        currentPage: this.currentPage,
                        currentElement: this.sliderItemsToShow[this.currentPage - 1]
                    }
                })
            );
        }

        if (this.enableSliderLooping) return;

        if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
            this.prevButton.setAttribute("disabled", "disabled");
        } else {
            this.prevButton.removeAttribute("disabled");
        }

        if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
            this.nextButton.setAttribute("disabled", "disabled");
        } else {
            this.nextButton.removeAttribute("disabled");
        }
    }

    isSlideVisible(element, offset = 0) {
        const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
        return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }

    onButtonClick(event) {
        event.preventDefault();
        const step = event.currentTarget.dataset.step || 1;
        this.slideScrollPosition = event.currentTarget.name === "next" ? this.slider.scrollLeft + step * this.sliderItemOffset : this.slider.scrollLeft - step * this.sliderItemOffset;
        this.slider.scrollTo({
            left: this.slideScrollPosition
        });
    }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
    constructor() {
        super();
        this.sliderControlWrapper = this.querySelector(".slider-buttons");
        this.enableSliderLooping = true;

        if (!this.sliderControlWrapper) return;

        this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
        if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

        this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link"));
        this.sliderControlLinksArray.forEach((link) => link.addEventListener("click", this.linkToSlide.bind(this)));
        this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
        this.setSlideVisibility();

        if (this.slider.getAttribute("data-autoplay") === "true") this.setAutoPlay();
    }

    setAutoPlay() {
        this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
        this.autoplaySpeed = this.slider.dataset.speed * 1000;

        this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this));
        this.addEventListener("mouseover", this.focusInHandling.bind(this));
        this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
        this.addEventListener("focusin", this.focusInHandling.bind(this));
        this.addEventListener("focusout", this.focusOutHandling.bind(this));

        this.play();
        this.autoplayButtonIsSetToPlay = true;
    }

    onButtonClick(event) {
        super.onButtonClick(event);
        const isFirstSlide = this.currentPage === 1;
        const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

        if (!isFirstSlide && !isLastSlide) return;

        if (isFirstSlide && event.currentTarget.name === "previous") {
            this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
        } else if (isLastSlide && event.currentTarget.name === "next") {
            this.slideScrollPosition = 0;
        }
        this.slider.scrollTo({
            left: this.slideScrollPosition
        });
    }

    update() {
        super.update();
        this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
        this.prevButton.removeAttribute("disabled");

        if (!this.sliderControlButtons.length) return;

        this.sliderControlButtons.forEach((link) => {
            link.classList.remove("slider-counter__link--active");
            link.removeAttribute("aria-current");
        });
        this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active");
        this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", true);
    }

    autoPlayToggle() {
        this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
        this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
        this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
    }

    focusOutHandling(event) {
        const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
        if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
        this.play();
    }

    focusInHandling(event) {
        const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
        if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
            this.play();
        } else if (this.autoplayButtonIsSetToPlay) {
            this.pause();
        }
    }

    play() {
        this.slider.setAttribute("aria-live", "off");
        clearInterval(this.autoplay);
        this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }

    pause() {
        this.slider.setAttribute("aria-live", "polite");
        clearInterval(this.autoplay);
    }

    togglePlayButtonState(pauseAutoplay) {
        if (pauseAutoplay) {
            this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
            this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow);
        } else {
            this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
            this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow);
        }
    }

    autoRotateSlides() {
        const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector(".slideshow__slide").clientWidth;
        this.slider.scrollTo({
            left: slideScrollPosition
        });
    }

    setSlideVisibility() {
        this.sliderItemsToShow.forEach((item, index) => {
            const linkElements = item.querySelectorAll("a");
            if (index === this.currentPage - 1) {
                if (linkElements.length)
                    linkElements.forEach((button) => {
                        button.removeAttribute("tabindex");
                    });
                item.setAttribute("aria-hidden", "false");
                item.removeAttribute("tabindex");
            } else {
                if (linkElements.length)
                    linkElements.forEach((button) => {
                        button.setAttribute("tabindex", "-1");
                    });
                item.setAttribute("aria-hidden", "true");
                item.setAttribute("tabindex", "-1");
            }
        });
    }

    linkToSlide(event) {
        event.preventDefault();
        const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({
            left: slideScrollPosition
        });
    }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.addEventListener("change", this.onVariantChange);
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, "", false);
        this.removeErrorMessage();
        this.updateVariantStatuses();

        if (!this.currentVariant) {
            this.toggleAddButton(true, "", true);
            this.setUnavailable();
        } else {
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll("select"), (select) => select.value);
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options
                .map((option, index) => {
                    return this.options[index] === option;
                })
                .includes(false);
        });
    }

    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;

        const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
        mediaGalleries.forEach((mediaGallery) => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

        const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        if (!modalContent) return;
        const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        modalContent.prepend(newMediaModal);
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === "false") return;
        window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event("change", { bubbles: true }));
        });
    }

    updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData.filter((variant) => this.querySelector(":checked").value === variant.option1);
        const inputWrappers = [...this.querySelectorAll(".product-form__input")];
        inputWrappers.forEach((option, index) => {
            if (index === 0) return;
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
            const previousOptionSelected = inputWrappers[index - 1].querySelector(":checked").value;
            const availableOptionInputsValue = selectedOptionOneVariants.filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected).map((variantOption) => variantOption[`option${index + 1}`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach((input) => {
            if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
                input.innerText = input.getAttribute("value");
            } else {
                input.innerText = window.variantStrings.unavailable_with_option.replace("[value]", input.getAttribute("value"));
            }
        });
    }

    removeErrorMessage() {
        const section = this.closest("section");
        if (!section) return;

        const productForm = section.querySelector("product-form");
        if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
        const requestedVariantId = this.currentVariant.id;
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

        fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
            .then((response) => response.text(), { cache: 'no-cache'})
            .then((responseText) => {
                // prevent unnecessary ui changes from abandoned selections
                if (this.currentVariant.id !== requestedVariantId) return;

                const existingReserveInStoreModal = document.getElementById(`PopupModal-reserve-in-store`);
                if (existingReserveInStoreModal) existingReserveInStoreModal.remove();
                const existingRestockNotificationModal = document.getElementById(`PopupModal-restock-notification`);
                if (existingRestockNotificationModal) existingRestockNotificationModal.remove();

                const html = new DOMParser().parseFromString(responseText, "text/html");
                const destination = document.getElementById(`price-${this.dataset.section}`);
                const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
                const productSKUSource = html.getElementById(`ProductSKU-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                const productSKUDestination = document.getElementById(`ProductSKU-${this.dataset.section}`);
                const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
                const productStockStatusSource = html.getElementById(`ProductStockStatus-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                const productStockStatusDestination = document.getElementById(`ProductStockStatus-${this.dataset.section}`);
                const reserveRestockSource = html.getElementById(`ProductReserveRestock-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                const reserveRestockDestination = document.getElementById(`ProductReserveRestock-${this.dataset.section}`);
                const reserveRestockButtonsSource = html.getElementById(`ProductReserveRestockButtons-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                const reserveRestockButtonsDestination = document.getElementById(`ProductReserveRestockButtons-${this.dataset.section}`);
                const variantRadiosLegendSource = html.getElementById(`variant-radios-legend-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                const variantRadiosLegendDestination = document.getElementById(`variant-radios-legend-${this.dataset.section}`);
                const variantRadioQtyStockSource = html.getElementById(`variant-radios-qtystock-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                const variantRadioQtyStockDestination = document.getElementById(`variant-radios-qtystock-${this.dataset.section}`);
                const mainProductStickySource = html.getElementById(`main-product-sticky-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                const mainProductStickyDestination = document.getElementById(`main-product-sticky-${this.dataset.section}`);

                if (source && destination) destination.innerHTML = source.innerHTML;
                if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
                if (skuSource && skuDestination) {
                    skuDestination.innerHTML = skuSource.innerHTML;
                    skuDestination.classList.toggle("visibility-hidden", skuSource.classList.contains("visibility-hidden"));
                }
                if (productSKUSource && productSKUDestination) productSKUDestination.innerHTML = productSKUSource.innerHTML;
                if (productStockStatusSource && productStockStatusDestination) productStockStatusDestination.innerHTML = productStockStatusSource.innerHTML;
                if (reserveRestockButtonsSource && reserveRestockButtonsDestination) reserveRestockButtonsDestination.innerHTML = reserveRestockButtonsSource.innerHTML;
                if (reserveRestockSource && reserveRestockDestination) reserveRestockDestination.innerHTML = reserveRestockSource.innerHTML;
                if (variantRadiosLegendSource && variantRadiosLegendDestination) variantRadiosLegendDestination.innerHTML = variantRadiosLegendSource.innerHTML;
                if (variantRadioQtyStockSource && variantRadioQtyStockDestination) variantRadioQtyStockDestination.innerHTML = variantRadioQtyStockSource.innerHTML;
                if (mainProductStickySource && mainProductStickyDestination) mainProductStickyDestination.innerHTML = mainProductStickySource.innerHTML;

                const price = document.getElementById(`price-${this.dataset.section}`);

                if (price) price.classList.remove("visibility-hidden");

                if (inventoryDestination) inventoryDestination.classList.toggle("visibility-hidden", inventorySource.innerText === "");

                const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
                this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true, window.variantStrings.soldOut);

                publish(PUB_SUB_EVENTS.variantChange, {
                    data: {
                        sectionId,
                        html,
                        variant: this.currentVariant
                    }
                });
            });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        addButton.dataset.soldOut = disable && text ? "true" : "false";

        const reserveRestockForm = document.querySelector(".product__reserve-restock");
        const reserveInStoreButton = reserveRestockForm ? reserveRestockForm.querySelector('[name="reserve-in-store"]') : false;
        const restockNotificationButton = reserveRestockForm ? reserveRestockForm.querySelector('[name="restock-notification"]') : false;

        if (disable) {
            addButton.setAttribute("disabled", "disabled");
            if (text) addButtonText.textContent = text;

            if (!text) {
                if (reserveInStoreButton) reserveInStoreButton.setAttribute("disabled", "disabled");
                if (restockNotificationButton) restockNotificationButton.setAttribute("disabled", "disabled");
            }
        } else {
            addButton.removeAttribute("disabled");
            addButtonText.textContent = window.variantStrings.addToCart;

            if (reserveInStoreButton) reserveInStoreButton.removeAttribute("disabled");
            if (restockNotificationButton) restockNotificationButton.removeAttribute("disabled");
        }

        if (!modifyClass) return;
    }

    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);

        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add("visibility-hidden");
        if (inventory) inventory.classList.add("visibility-hidden");
        if (sku) sku.classList.add("visibility-hidden");
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach((input) => {
            if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
                input.classList.remove("disabled");
            } else {
                input.classList.add("disabled");
            }
        });
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll("fieldset"));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value;
        });
    }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            fetch(this.dataset.url)
                .then((response) => response.text())
                .then((text) => {
                    const html = document.createElement("div");
                    html.innerHTML = text;
                    const recommendations = html.querySelector("product-recommendations");

                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                    }

                    if (!this.querySelector("slideshow-component") && this.classList.contains("complementary-products")) {
                        this.remove();
                    }

                    if (html.querySelector(".grid__item")) {
                        this.classList.add("product-recommendations--loaded");
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
        };

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
    }
}

customElements.define("product-recommendations", ProductRecommendations);

// ------

class ProductColors extends HTMLElement {
    constructor() {
        super();
        this.addEventListener("change", this.onProductColorChange);

        // add event for hover on labels
        this.querySelectorAll("label").forEach((label) => {
            label.addEventListener("mouseenter", this.onProductColorMouseOver);
            label.addEventListener("mouseleave", this.onProductColorMouseOut);
        });
    }

    onProductColorMouseOver(e) {
        e.target.querySelector(".product__color-grid-tooltip").classList.add("is-showing");
    }
    onProductColorMouseOut(e) {
        e.target.querySelector(".product__color-grid-tooltip").classList.remove("is-showing");
    }

    onProductColorChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, "", false);
        this.renderProductInfo();
    }

    updateOptions() {
        let radioNodes = Array.from(this.querySelectorAll("input"));
        this.checkedRadioValue = radioNodes.find((radio) => radio.checked).value;
    }

    updateMasterId() {
        let data = JSON.parse(this.querySelector(`[type="application/json"]`).textContent);
        this.currentProductColor = data.find((variant) => {
            return variant.id == this.checkedRadioValue;
        });
    }

    updateURL() {
        if (!this.currentProductColor) return;
        // get current variant id
        window.history.replaceState({}, "", `${this.currentProductColor.handle}?variant=${this.currentProductColor.id}`);
    }

    updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}/products/${this.currentProductColor.handle}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
        productForms.forEach((productForm) => {
            const currentVariant = this.getCurrentVariant();
            const input = productForm.querySelector('input[name="id"]');
            input.value = currentVariant.id;
            input.dispatchEvent(new Event("change", { bubbles: true }));
        });
    }

    updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData.filter((variant) => this.querySelector(":checked").value === variant.option1);
        const inputWrappers = [...this.querySelectorAll(".product-form__input")];
        inputWrappers.forEach((option, index) => {
            if (index === 0) return;
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
            const previousOptionSelected = inputWrappers[index - 1].querySelector(":checked").value;
            const availableOptionInputsValue = selectedOptionOneVariants.filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected).map((variantOption) => variantOption[`option${index + 1}`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach((input) => {
            if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
                input.classList.remove("disabled");
            } else {
                input.classList.add("disabled");
            }
        });
    }

    getCurrentVariant() {
        let optionsArray = [];
        if (document.querySelectorAll(`#variant-radios-${this.dataset.section} fieldset`).length) {
            const fieldsets = Array.from(document.querySelectorAll(`#variant-radios-${this.dataset.section} fieldset`));
            optionsArray = fieldsets.map((fieldset) => {
                return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value;
            });
        }
        if (document.querySelectorAll(`#variant-selects-${this.dataset.section}`).length) {
            const fieldsets = Array.from(document.querySelectorAll(`#variant-selects-${this.dataset.section} .select`));
            optionsArray = fieldsets.map((fieldset) => {
                return Array.from(fieldset.querySelectorAll("option")).find((option) => option.selected).value;
            });
        }
        const currentVariant = this.variantData.find((variant) => {
            return !variant.options
                .map((option, index) => {
                    return optionsArray[index] === option;
                })
                .includes(false);
        });
        return currentVariant;
    }

    removeErrorMessage() {
        const section = this.closest("section");
        if (!section) return;

        const productForm = section.querySelector("product-form");
        if (productForm) productForm.handleErrorMessage();
    }

    async renderProductInfo() {
        const productInfoSectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        const requestedColourId = this.currentProductColor.id;

        // get product info section and update html
        const searchParams = new URLSearchParams();
        searchParams.append("section_id", productInfoSectionId);

        const response = await fetch(`${this.currentProductColor.handle}/?${searchParams.toString()}`);
        if (!response.ok) throw new Error("Network response was not ok");

        let productInfoSection = await response.text();

        // If responseText includes window.location.href, refetch with the direct URL.
        if (productInfoSection.includes('data-redirect-variant-url')) {
            const match = productInfoSection.match(/data-redirect-variant-url="([^"]+)"/);
            if (!match) {
                throw new Error("Failed to extract redirect URL from data-redirect-variant-url attribute");
            }
            const redirectUrl = match[1];
            const redirectResponse = await fetch(`${redirectUrl}&${searchParams.toString()}`);
            if (!redirectResponse.ok) {
                throw new Error(`Failed to fetch redirected product info: ${redirectResponse.status} ${redirectResponse.statusText}`);
            }

            productInfoSection = await redirectResponse.text();
        }

        // Prevent unnecessary UI changes from abandoned selections
        if (this.currentProductColor.id !== requestedColourId) return;

        const existingReserveInStoreModal = document.getElementById(`PopupModal-reserve-in-store`);
        if (existingReserveInStoreModal) existingReserveInStoreModal.remove();
        const existingRestockNotificationModal = document.getElementById(`PopupModal-restock-notification`);
        if (existingRestockNotificationModal) existingRestockNotificationModal.remove();

        // Parse the returned HTML
        const sourceHTML = new DOMParser().parseFromString(productInfoSection, "text/html");

        // Get source and destination section ids
        const sourceSectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        const destinationSectionId = this.dataset.section;

        // Define elements to find and replace
        const findReplaceElements = [
            {
                element: "price",
                modifier: (sourceElement, destinationElement) => {
                    if (!destinationElement) return;
                    destinationElement.classList.remove("visibility-hidden");
                }
            },
            {
                element: "Sku", modifier: (sourceElement, destinationElement) => {
                    if (!destinationElement) return;
                    destinationElement.classList.toggle("visibility-hidden", sourceElement ? sourceElement.classList.contains("visibility-hidden") : true);
                }
            },
            "ProductSKU",
            {
                element: "Inventory",
                modifier: (sourceElement, destinationElement) => {
                    if (!destinationElement) return;
                    destinationElement.classList.toggle("visibility-hidden", sourceElement ? sourceElement.innerText === "" : true);
                }
            },
            "ProductVendor",
            "ProductTitle",
            "ProductSecondaryColor",
            "ReviewSummary",
            {
                element: "MediaGallery",
                modifier: (sourceElement, destinationElement) => {
                    if (!sourceElement) return;

                    // update class on .product based on whether has media
                    const img = sourceElement.querySelector("img");
                    const mainProductLayoutElement = document.getElementById(`MainProductLayout-${destinationSectionId}`);

                    const noMediaClass = 'product--no-media';
                    if (img) mainProductLayoutElement.classList.remove(noMediaClass);
                    else mainProductLayoutElement.classList.add(noMediaClass);
                }
            },
            "ProductDescription",
            "ProductModal",
            "ProductStockStatus",
            "ProductReserveRestockButtons",
            "ProductReserveRestock",
            "main-product-sticky",
            "ProductPopups",
            "variant-radios-legend",
            "variant-radios-qtystock",
            "variant-selects",
            "variant-radios"
        ];

        // Perform find and replace operations
        for (const item of findReplaceElements) {
            const element = typeof item === "object" ? item.element : item;
            const skipReplace = typeof item === "object" ? item.skipReplace || false : false;

            const sourceElement = sourceHTML.getElementById(`${element}-${sourceSectionId}`);
            const destinationElement = document.getElementById(`${element}-${destinationSectionId}`);
            if (!sourceElement || !destinationElement) continue;

            if (!skipReplace) destinationElement.innerHTML = sourceElement.innerHTML;

            // Apply any modifiers if present.
            if (typeof item !== 'object') continue;

            if (item.modifier && typeof item.modifier === 'function') {
                item.modifier(sourceElement, destinationElement);
            }
        }

        const usingRadios = sourceHTML.getElementById(`variant-radios-${sourceSectionId}`);
        const usingSelects = sourceHTML.getElementById(`variant-selects-${sourceSectionId}`);
        const hasVariantSelector = usingRadios || usingSelects;

        // Update variant input if no variant selector present
        if (!hasVariantSelector) {
            const variantInputElementId = 'product-variant-id';
            const newVariantId = sourceHTML.getElementById(`${variantInputElementId}-${sourceSectionId}`).value;
            const variantInputElement = document.getElementById(`${variantInputElementId}-${this.dataset.section}`);
            if (newVariantId && variantInputElement) variantInputElement.value = newVariantId;
        }

        // update add button
        const addButtonUpdated = sourceHTML.getElementById(`ProductSubmitButton-${productInfoSectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true, window.variantStrings.soldOut);

        // update data-url attribute for product form and variant radios
        document.getElementById(`ProductInfo-${destinationSectionId}`).setAttribute("data-url", `/products/${this.currentProductColor.handle}`);
        if (usingRadios) {
            document.getElementById(`variant-radios-${destinationSectionId}`).setAttribute("data-url", `/products/${this.currentProductColor.handle}`);
        }
        if (usingSelects) {
            document.getElementById(`variant-selects-${destinationSectionId}`).setAttribute("data-url", `/products/${this.currentProductColor.handle}`);
        }

        if (hasVariantSelector) {
            this.getVariantData();
            this.updateVariantStatuses();
        }
        this.removeErrorMessage();

        if (usingRadios) {
            const variantRadios = document.getElementById(`variant-radios-${destinationSectionId}`);
            if (variantRadios) {
                variantRadios.variantData = undefined; // clear so doesn't use last product's variant data
            }
        }
        if (usingSelects) {
            const variantSelects = document.getElementById(`variant-selects-${destinationSectionId}`);
            if (variantSelects) {
                variantSelects.variantData = undefined; // clear so doesn't use last product's variant data
            }
        }

        if (!this.currentProductColor) {
            this.toggleAddButton(true, "", true);
            this.setUnavailable();
        } else {
            this.updateURL();
            if (hasVariantSelector) this.updateVariantInput();
            this.updateShareUrl();
        }
        publish(PUB_SUB_EVENTS.productColorChange, {
            data: {
                sectionId: productInfoSectionId,
                html: sourceHTML,
                color: this.currentProductColor
            }
        });

        // render the other sections on the page
        // get sections that aren't the main product
        fetch(`${this.currentProductColor.handle}?variant=${requestedColourId}`)
            .then((response) => response.text())
            .then((responseText) => {
                // get new html content
                const allSectionsHTML = new DOMParser().parseFromString(responseText, "text/html");
                const allSections = Array.from(allSectionsHTML.querySelectorAll(`#MainContent > *`));
                const otherSections = allSections.filter((s) => !s.classList.contains("section--main-product"));

                // get index of section--main-product
                const mainProductIndex = allSections.findIndex((s) => s.classList.contains("section--main-product"));

                // remove existing sections that aren't main product
                const allExistingSections = Array.from(document.querySelectorAll(`#MainContent > *`));
                const otherExistingSections = allExistingSections.filter((s) => !s.classList.contains("section--main-product"));
                // delete each of otherExistingSections from DOM
                otherExistingSections.forEach((otherExistingSection) => {
                    otherExistingSection.remove();
                });

                // add new sections in, before or after main product, depending on main product index
                const mainProductNode = document.querySelector(`#MainContent > .section--main-product`);
                const mainContentNode = document.querySelector(`#MainContent`);
                otherSections.forEach((otherSection, index) => {
                    if (index < mainProductIndex) {
                        mainProductNode.insertAdjacentHTML("beforebegin", otherSection.outerHTML);
                    } else {
                        // add to the end of main content
                        mainContentNode.insertAdjacentHTML("beforeend", otherSection.outerHTML);
                    }
                });

                // update title
                const titleSource = allSectionsHTML.querySelector(`title`);
                const titleDestination = document.querySelector(`title`);
                if (titleSource && titleDestination) titleDestination.innerHTML = titleSource.innerHTML;

                // update blocks (should be in the other request, but section api wasn't returning correct blocks)
                const blocksSource = allSectionsHTML.querySelector(`.section--main-product [id^="ProductBlocks-"]`);
                const blocksDestination = document.querySelector(`.section--main-product [id^="ProductBlocks-"]`);
                if (blocksSource && blocksDestination) blocksDestination.innerHTML = blocksSource.innerHTML;

                // alter sezzle price
                if (renderSezzle) {
                    const newSezzlePrice = allSectionsHTML.querySelector(`.section--main-product [id^="ProductSezzle-"]`).getAttribute("data-price");
                    renderSezzle.alterPrice(newSezzlePrice);
                }

                // re-render reviews
                const sprNode = document.querySelector(`#shopify-product-reviews`);
                if (sprNode) {
                    // clear out existing product reviews
                    sprNode.innerHTML = "";
                    sprNode.dataset.id = this.currentProductColor.id;

                    // reload product reviews js
                    let scriptNode = document.createElement("script");
                    scriptNode.type = "text/javascript";
                    scriptNode.async = true;
                    scriptNode.src = "//productreviews.shopifycdn.com/embed/loader.js?shop=2bb047.myshopify.com";
                    let scriptInsertLocation = document.getElementsByTagName("script")[0];
                    scriptInsertLocation.parentNode.insertBefore(scriptNode, scriptInsertLocation);
                }
            });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        const reserveInStoreButton = productForm.querySelector('[name="reserve-in-store"]');
        const restockNotificationButton = productForm.querySelector('[name="restock-notification"]');

        if (disable) {
            addButton.setAttribute("disabled", "disabled");
            if (text) addButtonText.textContent = text;

            if (!text) {
                if (reserveInStoreButton) reserveInStoreButton.setAttribute("disabled", "disabled");
                if (restockNotificationButton) restockNotificationButton.setAttribute("disabled", "disabled");
            }
        } else {
            addButton.removeAttribute("disabled");
            addButtonText.textContent = window.variantStrings.addToCart;

            if (reserveInStoreButton) reserveInStoreButton.removeAttribute("disabled");
            if (restockNotificationButton) restockNotificationButton.removeAttribute("disabled");
        }

        if (!modifyClass) return;
    }

    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);
        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add("visibility-hidden");
        if (inventory) inventory.classList.add("visibility-hidden");
        if (sku) sku.classList.add("visibility-hidden");
    }

    getVariantData() {
        if (document.querySelector(`#variant-radios-${this.dataset.section}`)) {
            this.variantData = JSON.parse(document.querySelector(`#variant-radios-${this.dataset.section} [type="application/json"]`).textContent);
        } else {
            this.variantData = JSON.parse(document.querySelector(`#variant-selects-${this.dataset.section} [type="application/json"]`).textContent);
        }
        return this.variantData;
    }
}

customElements.define("product-colors", ProductColors);


const removeNoJS = () => {
    const noJsElements = document.body.querySelectorAll(".no-js");
    noJsElements.forEach((element) => {
        element.remove("no-js");
    });
};

const addNewWindowIndicatorToLinks = () => {
    const targetBlankLinks = document.querySelectorAll('a[target="_blank"]');
    const svgns = "http://www.w3.org/2000/svg";
    const xlinkns = "http://www.w3.org/1999/xlink";
    targetBlankLinks.forEach(function(link) {
        const linkLabel = link.textContent.trim();
        link.setAttribute("aria-label", `${linkLabel} (Opens in new window)`);

        const symbol = document.createElementNS(svgns, 'svg');
        symbol.classList.add('new-window-indicator');
        symbol.setAttribute('role', 'presentation');

        const use = document.createElementNS(svgns, 'use');
        use.setAttributeNS(xlinkns, 'href', '#icon-popout');
        symbol.appendChild(use);

        link.appendChild(symbol);
    });
};

document.addEventListener("DOMContentLoaded", () => {
    removeNoJS();
    addNewWindowIndicatorToLinks();
});